module.exports = __webpack_public_path__ + "static/media/Gene Ting-Chun Kao.280e9694.png";